import http from "@/http-common";

/* eslint-disable */
class McusDataService {
    getVinReadResult(data) {
        return http.api.post("/getVinReadResult", data);
    }
    getVinCheckedResult(data) {
        return http.api.post("/getVinCheckResult", data);
    }
    uploadCheckList(data) {
        return http.api.post("/uploadCheckList", data);
    }
    searchChecklist(data) {
        return http.api.post("/searchChecklist", data);
    }
    getChecklistImages(data) {
        return http.api.post("/getChecklistImages", data);
    }
    getLogoutTimeout() {
        return http.api.post("/getLogoutTimeout");
    }
}

export default new McusDataService();